// extracted by mini-css-extract-plugin
export default {"usps-validation-dialog":"usps-validation-dialog_usps-validation-dialog__RrO-u","description":"usps-validation-dialog_description__YlkBB"};